import { useCallback, useRef } from 'react';
import { Flex, RootScreen } from '@banhala/ui-kit';
import {
  useHasBeenFocusedTab,
  useInstanceId,
  useNativeScrollSync,
  useNativeScrollToTop,
} from 'shared/src/hooks';
import { TodayAtomic, type TodayAtomicHandle } from './components/TodayAtomic';

/**
 * 임시 테스트용. 홈탭 실험이 모두 완료되면. Home.screen.tsx로 통합 될 예정
 * @constructor
 */
export const FragmentTodayScreen = () => {
  const instanceId = useInstanceId();
  const { hasBeenFocused, setHasBeenFocused } = useHasBeenFocusedTab();

  const todayRef = useRef<TodayAtomicHandle>(null);

  // native HomePagerVC 의 floating button 토글 + scrollToTop 동기화.
  // RN 스크롤 → onScrollEvent → animateFloatingButton (ReactNativeEmbeddedVC.swift)
  const { onScroll: onScrollSync } = useNativeScrollSync({ instanceId });

  const scrollToTop = useCallback(() => {
    todayRef.current?.scrollToTop();
  }, []);

  useNativeScrollToTop({ onScrollToTop: scrollToTop, screen: 'TODAY' });

  return (
    <RootScreen>
      <Flex
        flex={1}
        onPress={() => {}}
        onPressIn={() => {
          console.log('onPressIn');
          setHasBeenFocused(true);
        }}
        onPressOut={() => {
          console.log('onPressOut');
        }}
      >
        {hasBeenFocused && (
          <TodayAtomic
            ref={todayRef}
            screenName={'TODAY'}
            onScrollY={onScrollSync}
          />
        )}
      </Flex>
    </RootScreen>
  );
};
